module.exports = __webpack_public_path__ + "img/user-3.08cebfd7.jpg";